import { Permission } from 'entities/user';

export type PermissionsObject = { [key in Permission]: boolean };

export function constructPermissionsObject(permissions: Permission[]): PermissionsObject {
  const newPermissions: PermissionsObject = {
    Debug: false,
    ManageAssets: false,
    ManageCampaigns: false,
    ManageClients: false,
    ManageDispatchers: false,
    ManageEnrichments: false,
    ManageThirdPartyConsent: false,
    ManageFiles: false,
    ManageLinks: false,
    ManageSftpUsers: false,
    ManageTemplates: false,
    ManageTrends: false,
    ManageUnsubscribes: false,
    ManageUsers: false,
    ManageVoucherCodes: false,
    ViewAll: false,
    ViewDashboards: false,
  };

  permissions.forEach(perm => (newPermissions[perm] = true));
  return newPermissions;
}

export function constructPermissionsArray(permissions: PermissionsObject): Permission[] {
  const newPermissions: Permission[] = [];

  for (const key in permissions) {
    if (permissions[key]) newPermissions.push(key as Permission);
  }

  return newPermissions;
}
